import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import Blog from './pages/Blog';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import AdminCandidatures from './pages/AdminCandidatures';

const App = () => {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/candidatures" element={<AdminCandidatures />} />
          <Route path="/" element={<Home />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/realisations" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/carriere" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </Router>
  );
};

export default App;